import { atom } from 'jotai';
import { FileTypes } from '../typings/file-types';

export const fileTypesAtom = atom<FileTypes | undefined>(undefined);
